/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useState } from 'react';
import Loader from '../../common/Loader';
import { useFetchTournamentsByDate } from '../../data/fetchTournamentsByDate';
import { getConfiguration } from '../../data/utils/configuration';
import { getPrincipaleOPrimoMacroGruppo } from '../../data/utils/getPrincipaleOPrimoMacroGruppo';
import { iconCategoryCssClass } from '../../data/utils/iconCategoryCssClass';
import { iconSportCssClass } from '../../data/utils/iconSportCssClass';
import LandingMatch from '../match/LandingMatch';
import SportsDropdown from './SportsDropdown';

function getTimeLimit(type) {
    switch (type) {
        case '1H':
        return 1;
        case '3H':
        return 3;
        default:
        return null;
    }
}

function EventsByDateSingleSport(props) {
    const conf = getConfiguration();
    const sport = props.sport;
    const [state, setState] = useState({
        data: null,
        date: props.filter.date,
        hoursLimit: getTimeLimit(props.filter.type),
        sportFetch: sport,
        sport,
        macrogruppo: null,
        aggregata: null,
        bet: null,
        aggregataFetch: sport.aggregata,
        match: null,
        update(updt) {
            setState(prev => {
                return {...prev, ...updt};
            });
        },
        setData(data) {
            let macrogruppo = this.macrogruppoFetch;
            if (macrogruppo == null) {
                macrogruppo = data.macrogruppi.find(mg => mg.id === this.sportFetch.macrogruppo) || getPrincipaleOPrimoMacroGruppo(data.macrogruppi);
            }
            let firstMatch = this.match || data.matches[0];
            if (firstMatch != null) {
                const mg = data.macrogruppi.find(mg => mg.id === firstMatch.openMacrogruppo);
                if (mg && this.macrogruppo && mg.id !== this.macrogruppo.id) {
                    macrogruppo = mg;
                }
            }
            const bet = macrogruppo.aggregate.find(ag => ag.idAggregata === this.aggregataFetch).scommesse[0];
            const sport = data.sportById.get(this.sportFetch.id);
            this.update({data, sport, macrogruppo, aggregata: this.aggregataFetch, bet, match: firstMatch});
        },
        changeDate(filter) {
            const sport = filter.sport;
            this.update({date: filter.date, sportFetch: sport, macrogruppoFetch: null, aggregataFetch: sport.aggregata, match: null});
        },
        changeMatch(match) {
            this.update({match});
        }
    });

    const [request] = useFetchTournamentsByDate(state.date, state.sportFetch.id, state.aggregataFetch, state.hoursLimit);
    const [showLoader, setShowLoader] = useState(true);
    useEffect(function() {
        let timeout = null;
        if (request.isLoading) {
            timeout = setTimeout(function() {
                setShowLoader(true);
            }, conf.lspt);
        } else {
            clearTimeout(timeout);
            setShowLoader(false);
            if (!request.isError) {
                state.setData(request.data);
            }
        }

        return () => {
            clearInterval(timeout);
        };
    }, [request]);

    const observerRef = useCallback((node) => {
        if (node != null && props.loadNextSport) {
            const currentSport = state.sport.id;
            const index = state.data.sport.findIndex(s => s.id === currentSport);
            if (index < state.data.sport.length - 1) {
                const nextSport = state.data.sport[index + 1];
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            props.addSport(nextSport);
                            observer.disconnect();
                        }
                    });
                });
                observer.observe(node);
            }
        }
    }, [state.data, props.loadNextSport]);

    const observerIndex = useCallback(() => {
        const length = state.data?.matches?.length;
        if (length !== undefined) {
            if (length <= 20) {
                return 0;
            } else {
                return length - 1;
            }
        }
    }, [state.data?.matches?.length])();

    if (showLoader) {
        return <Loader error={request.isError} />;
    } else if (state.data.matches.length === 0) {
        return (
            <span ref={observerRef}></span>
        );
    }

    const sportIcon = iconSportCssClass(state.sport.id, state.sport.iconClass);
    const sportDesc = state.sport.descrizione;

    let prevTournament = null;
    let tournaments = [];
    state.data.matches.forEach((match, i) => {
        if (match.tournamentRef !== prevTournament?.id) {
            const t = state.data.tournamentById.get(match.tournamentRef);
            const icon = iconCategoryCssClass(t.sportRef, t.categoryRef, t.iconClass);
            const uniqueId = `${t.sportRef}_${t.categoryRef}_${t.id}`;
            const sport = props.data?.sportById?.[t.sportRef];
            const country = sport?.categoryById?.[t.categoryRef];
            const desc = country ? `${country.descrizione} - ${t.desc}` : t.desc;
            const tournament = {
                id: match.tournamentRef,
                uniqueId,
                sportIcon,
                sportDesc,
                categoryIcon: icon,
                desc,
                matches: []
            };
            tournaments.push(tournament);
            prevTournament = tournament;
        }
        prevTournament.matches.push(match);
    });

    let matchIndex = 0;
    return (
        <>
            {props.showSportsMenu &&
                <SportsDropdown sports={state.data.sport}
                                selectedSport={props.selectedSport}
                                openSingleSport={props.openSingleSport}
                                openAllSports={props.openAllSports} />
            }
            <div id="avvenimenti" className="events-by-date header-template-2">
                {tournaments.map(t => {
                    return (
                        <div key={t.uniqueId}>
                            <div className="header-wrapper">
                                <div className="header">
                                    <div className="header-details">
                                        <div className={"prematch-sport-img big " + t.categoryIcon}></div>
                                        <span className="header-details-title">{t.desc}</span>
                                    </div>
                                </div>
                            </div>
                            <div className="details-header">
                                <div className="details-header-wrapper">
                                    <span className="sport-info-container">
                                        <span className={"sport-icon sport-img " + sportIcon}></span>
                                        <span className="sport-desc upper-case">{sportDesc}</span>
                                    </span>
                                </div>
                            </div>
                            {t.matches.map((m, i) => {
                                matchIndex++;
                                return (
                                    <React.Fragment key={m.uniqueId}>
                                        <LandingMatch match={m} aggregata={state.aggregata} firstBetOnly={true} />
                                        {(matchIndex - 1) === observerIndex &&
                                            <span ref={observerRef}></span>
                                        }
                                    </React.Fragment>
                                );
                            })}
                        </div>
                    );
                })}
            </div>
        </>
    );
}

export default EventsByDateSingleSport;